import React from 'react'
import { Trans } from 'react-i18next'

/** Dashboard container step component */
export const DashboardContainerStep: React.FC = () => {
  return <Trans i18nKey={'emobility.tour.dashboard-container'} components={{ strong: <strong /> }} />
}
